angular.module('pitch.app')
.directive('satvInViewport', function($timeout, $window, $document) {
    "use strict";
    return {
        restrict: 'A',
        link: function($scope, elem, attr, ctrl) {
            var $win, body, isChecking, detatch;

            $win = angular.element($window);
            body = $document[0].body;
            detatch = attr.satvInViewportDetach === "false" ? false : true;

            function isElementInViewport() {
                var rect = elem[0].getBoundingClientRect();

                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= ($window.innerHeight || body.clientHeight) &&
                    rect.right <= ($window.innerWidth || body.clientWidth)
                );
            }

            function handleScroll() {
                if (!isChecking) {
                    isChecking = true;
                    $timeout(function() {
                        if (isElementInViewport()) {
                            $scope.$eval(attr.satvInViewport);

                            //remove scroll handler as soon as the element is in view once
                            if (detatch) {
                                $win.off("scroll", handleScroll);
                            }
                        }
                        isChecking = false;
                    }, 100);
                }
            }

            $win.on("scroll", handleScroll);

            $scope.$on('$destroy', function() {
                $win.off("scroll", handleScroll);
            });
        }
    };
})
;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/satvInViewport.js